import React, { Component } from "react";
import queryString from "query-string";
import axios from "axios";

import { config } from "../../constants";
const jwt = require("jsonwebtoken");
const moment = require("moment");

// import axios from 'axios';

export class loginCallback extends Component {

  componentDidMount = async () => {

    let resp = await axios.post(config.apiUrl + "/login/gtkn", {});

    // if (parseInt(resp.data.code) === 200) {
    //   localStorage.setItem('sys_token', resp.data.token);
    // }
    //console.log(window.location.search);
    const parsed = queryString.parse(window.location.search);
    //console.log(parsed);
    const code = parsed.code;
    const project = parsed.param;
    //console.log(code);
    var details = {
      code: code
    };
    var formBody = [];
    for (var property in details) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(details[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    // console.log(formBody);
    // const moment = require("moment");
    fetch(config.apiUrl + "/trueid/login", {
      method: "POST",
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Origin, X-Requested-With",
        Accept: "application/json",
        "Content-Type": "application/json",
        // "X-Custom-Header": (localStorage.getItem("sys_token") || '')
      },
      //redirect: "follow", // manual, *follow, error
      //referrer: "no-referrer", // no-referrer, *client
      body: JSON.stringify(details)
    })
      .then(response => response.json())
      .then(json => {
        if (json.access_token) {
          // console.log(json);
          const userData = jwt.decode(json.access_token);
          const getProfileBody = { ssoid: userData.sub, token: json.access_token };
          fetch(config.apiUrl + "/trueid/profile", {
            method: "POST",
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache",
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Headers": "Origin, X-Requested-With",
              Accept: "application/json",
              "Content-Type": "application/json",
              // "X-Custom-Header": (localStorage.getItem("sys_token") || '')
            },
            body: JSON.stringify(getProfileBody)
          })
            .then(response => response.json())
            .then(profile => {

              if (parseInt(profile.code) === 200) {
                const expires_at = moment().add(json.expires_in - 600, "s").format();
                localStorage.setItem("access_token", json.access_token);
                localStorage.setItem("user_login", profile.login_account);
                localStorage.setItem("expires_in", json.expires_in);
                localStorage.setItem("refresh_token", json.refresh_token);
                localStorage.setItem("expires_at", expires_at);
                window.location = config.baseUrl + "/shop/" + project;

              } else {
                alert("ขออภัยค่ะ ไม่สามารถเรียก Profile ได้");
                console.error("Error 3 :", profile);
              }
            })
            .catch(error2 => {
              alert("ไม่สามารถเรียก Profile ได้");
              //window.location = "/shop/" + project;
              console.error("Error 2 :", error2);
            });
        } else {
          alert("ขออภัยค่ะ ไม่สามารถ login ได้");
          console.error("Error 4:", json);
        }
      })
      .catch(error => {
        alert("ไม่สามารถ login ได้");
        //window.location = "/shop/" + project;
        console.error("Error:", error);
      });
  };
  render() {
    return <>Please Wait...</>;
  }
}

export default loginCallback;
